import React, { useState, useEffect } from 'react';
import { Share, X, Plus } from 'lucide-react';

const IOSInstallPrompt = ({ currentUser }) => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.navigator.standalone === true;
    const hasSeenPrompt = localStorage.getItem('ios-install-prompt-seen');
    const userInstallKey = currentUser?.id ? `ios-install-shown-${currentUser.id}` : null;
    const shownToUser = userInstallKey ? localStorage.getItem(userInstallKey) : null;

    // Show if on iOS, not in standalone mode, and either never seen globally OR new user hasn't seen it
    if (isIOS && !isStandalone && (!hasSeenPrompt || (currentUser?.id && !shownToUser))) {
      setTimeout(() => setShowPrompt(true), 3000);
    }
  }, [currentUser]);

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('ios-install-prompt-seen', 'true');
    if (currentUser?.id) {
      localStorage.setItem(`ios-install-shown-${currentUser.id}`, 'true');
    }
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end md:items-center justify-center p-4">
      <div className="bg-white rounded-t-2xl md:rounded-2xl max-w-md w-full p-6 relative animate-slide-up">
        <button
          onClick={handleDismiss}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <img src="/logo192.png" alt="RepConnect" className="w-12 h-12 rounded-lg" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Install RepConnect</h2>
          <p className="text-gray-600 text-sm">
            Install this app on your iPhone for quick and easy access when you're on the go.
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="bg-blue-100 p-2 rounded-lg mt-1">
              <span className="text-xl">1️⃣</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-700">
                Tap the <Share className="w-4 h-4 inline mx-1 text-blue-600" /> <strong>Share</strong> button at the bottom of your browser
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-blue-100 p-2 rounded-lg mt-1">
              <span className="text-xl">2️⃣</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-700">
                Scroll down and tap <Plus className="w-4 h-4 inline mx-1 text-blue-600" /> <strong>Add to Home Screen</strong>
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-blue-100 p-2 rounded-lg mt-1">
              <span className="text-xl">3️⃣</span>
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-700">
                Tap <strong>Add</strong> in the top right corner
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className="w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default IOSInstallPrompt;
